module.exports = __webpack_public_path__ + "img/stamp_yes.bde4f41a.png";